import { render } from "./ProfileForm.vue?vue&type=template&id=ded01be6&scoped=true&ts=true"
import script from "./ProfileForm.vue?vue&type=script&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&lang=ts"

import "./ProfileForm.vue?vue&type=style&index=0&id=ded01be6&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded01be6"]])

export default __exports__